import supabase from '@/supabase/supabase';

    // Updated with the new high-quality Cloudinary logo
    const LOGO_URL = "https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1779211733/Remove_Background_e9npzp.png";

    export const emailService = {
      async getTemplates() {
        return supabase.from('email_templates').select('*').order('template_key');
      },

      async updateTemplate(id, updates) {
        return supabase.from('email_templates').update(updates).eq('id', id).select().single();
      },

      compileTemplate(htmlContent, variables = {}) {
        let compiled = htmlContent;
        for (const [key, val] of Object.entries(variables)) {
          compiled = compiled.replace(new RegExp(`{{${key}}}`, 'g'), val);
        }

        // BIMI & Professional Header/Footer Wrap with the new logo
        return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta name="color-scheme" content="light dark">
      <meta name="supported-color-schemes" content="light dark">
      <script type="application/ld+json">
        {"@context": "http://schema.org", "@type": "Organization", "name": "Roaming Logos", "url": "https://roaminglogos.com", "logo": "${LOGO_URL}"}
      </script>
      <meta itemprop="image" content="${LOGO_URL}" />
      <meta property="og:image" content="${LOGO_URL}" />
      <link rel="icon" href="${LOGO_URL}" type="image/png" />
      <link itemprop="logo" href="${LOGO_URL}" />
      <title>Roaming Logos</title>
    </head>
    <body style="margin: 0; padding: 0; background-color: #f8fafc; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0" style="background-color: #f8fafc; padding: 40px 20px;">
        <tr>
          <td align="center">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" style="max-width: 600px; background-color: #ffffff; border-radius: 24px; overflow: hidden; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);">
              <tr>
                <td align="center" style="padding: 40px 40px 30px 40px; border-bottom: 1px solid #f1f5f9;">
                  <img src="${LOGO_URL}" alt="Roaming Logos" style="height: 100px; width: auto; display: block;" />
                </td>
              </tr>
              <tr>
                <td style="padding: 40px; color: #1e293b; line-height: 1.8; font-size: 16px;">
                  ${compiled}
                </td>
              </tr>
              <tr>
                <td align="center" style="background-color: #1e293b; padding: 40px; color: #94a3b8; font-size: 13px;">
                  <p style="margin: 0 0 10px 0; color: #ffffff; font-weight: bold; font-size: 15px;">Roaming Logos</p>
                  <p style="margin: 0 0 20px 0;">Island-wide Advertising Network</p>
                  <div style="height: 1px; background-color: #334155; width: 100px; margin: 0 auto 20px auto;"></div>
                  <p style="margin: 0;">© ${new Date().getFullYear()} Roaming Logos. All rights reserved.</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </body>
    </html>
    `;
      },

      async sendEmail({ to, subject, html }) {
        const API_KEY = import.meta.env.VITE_EMAILIT_API_KEY;
        if (!API_KEY) throw new Error("VITE_EMAILIT_API_KEY is missing.");

        try {
          const response = await fetch('https://api.emailit.com/v1/emails', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${API_KEY}`
            },
            body: JSON.stringify({
              from: 'Roaming Logos <noreply@app.roaminglogos.com>',
              to: Array.isArray(to) ? to : [to],
              subject,
              html
            })
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Emailit API Error: ${response.status}`);
          }

          return await response.json();
        } catch (error) {
          console.error('Email sending failed:', error);
          throw error;
        }
      }
    };